import React from "react";

import IconBase, { IconBaseProps } from "./IconBase";

/**
 * Kidney — 20×20 lab group icon (Figma 834:57).
 * Two kidney lobes + two ureter strokes.
 */
const IconKidney: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 20 20"
      {...props}
    >
      <g transform="translate(2.496 3.314)">
        <path d="M2.73174 9.49962C-1.79502 7.59037 -0.00852128 1.14587 3.13382 0.0810622C4.43741 -0.360659 5.87582 1.10479 5.86662 2.01467C5.86262 2.40808 5.65962 2.79167 5.44812 3.19129C5.17045 3.716 4.87812 4.26837 5.00224 4.90696C5.22095 6.032 5.46591 7.93029 4.83474 8.83137C4.20353 9.73246 3.56878 9.85267 2.73174 9.49962Z" />
      </g>
      <g transform="translate(11.578 3.314)">
        <path d="M2.73279 0.0810622C5.87517 1.14587 7.66167 7.59037 3.13492 9.49962C2.29784 9.85267 1.66309 9.73246 1.03192 8.83137C0.400752 7.93029 0.645711 6.032 0.864377 4.90696C0.988502 4.26837 0.69621 3.716 0.418502 3.19129C0.207002 2.79167 0.00400231 2.40808 4.39816e-05 2.01467C-0.00916435 1.10479 1.42925 -0.360659 2.73279 0.0810622Z" />
      </g>
      <g transform="translate(10.562 9.076)">
        <path d="M1.363 0.415625C1.39158 0.831333 1.39208 0.831292 1.39208 0.831292L1.39258 0.83125L1.3935 0.831166L1.39512 0.831041L1.39742 0.830874L1.39862 0.83075C1.39862 0.83075 1.39437 0.83125 1.38842 0.832208C1.37646 0.834125 1.3555 0.838125 1.32867 0.845708C1.27404 0.861208 1.20204 0.889541 1.13154 0.939791C1.01083 1.02575 0.833333 1.21667 0.833333 1.69842V7.72596C0.833333 7.72596 0.833333 7.726 0.416667 7.726C0 7.726 0 7.72579 0 7.72579V1.69842C0 0.962416 0.295666 0.511958 0.648124 0.260958C0.814208 0.142708 0.978791 0.0787084 1.10158 0.0439167C1.1635 0.026375 1.2165 0.0157917 1.25625 0.00941674C1.27617 0.00620841 1.293 0.0040412 1.30612 0.00258287C1.31271 0.00183287 1.31842 0.00124954 1.32312 0.000832876L1.3295 0.000291665L1.33217 0.000124772L1.33333 4.13259e-05L1.33387 0C1.33387 0 1.33442 -4.18996e-05 1.363 0.415625Z" />
      </g>
      <g transform="translate(7.982 9.076)">
        <path d="M0.0357501 0.415625C0.00716674 0.831333 0.00662486 0.831292 0.00662486 0.831292L0.00616709 0.83125L0.00520865 0.831166L0.00362476 0.831041L0.00129143 0.830874L0 0.83075C0 0.83075 0.00437507 0.83125 0.0102917 0.832208C0.0222917 0.834125 0.0432502 0.838125 0.0700418 0.845708C0.124667 0.861208 0.196667 0.889541 0.267208 0.939791C0.387917 1.02575 0.565417 1.21667 0.565417 1.69842V7.72596C0.565417 7.72596 0.565417 7.726 0.982084 7.726C1.39875 7.726 1.39875 7.72579 1.39875 7.72579V1.69842C1.39875 0.962416 1.10304 0.511958 0.750583 0.260958C0.584541 0.142708 0.419959 0.0787084 0.297125 0.0439167C0.23525 0.026375 0.18225 0.0157917 0.1425 0.00941674C0.122542 0.00620841 0.10575 0.0040412 0.0925835 0.00258287C0.0860002 0.00183287 0.0803335 0.00124954 0.0755835 0.000832876L0.0692081 0.000291665L0.0665832 0.000124772L0.0654165 4.13259e-05L0.0648332 0C0.0648332 0 0.0642917 -4.18996e-05 0.0357501 0.415625Z" />
      </g>
    </IconBase>
  );
};

export default IconKidney;
